// The events of the company, one record each. Shared by the pages and the build
// scripts, so the file is CommonJS like the profile source.
//
//   id       key of the event's texts in translations/pages/events/<language>.js
//   date     first day, ISO (YYYY-MM-DD)
//   endDate  last day of an event that runs over several days (optional)
//   url      page of the event or of its organiser (optional)
//
// Order does not matter: the pages sort by date and decide from the date
// whether an event is upcoming or past.
const events = [
  { id: 'wikki26', date: '2026-03-10' }
];

module.exports = { events };
